/**
 * Публичная поверхность раздела «Визы» — ровно то, что нужно приложению снаружи:
 * набор роутов для роутера и точка входа для мест, где раздел рекламируется.
 * Всё остальное (страницы, диалог, пакет документов, черновик, аналитика,
 * конфигурация бота) — внутренности фичи и наружу не экспортируется.
 */
export { visaRoutes } from './routes';
export { useVisaHelpEntry } from './model/use-visa-entry';
export { default as VisaHelpOfferCard } from './ui/offer/VisaHelpOfferCard.vue';
